import { render } from "./PopupHuyCapTheChoNhanVien.vue?vue&type=template&id=07dface6"
import script from "./PopupHuyCapTheChoNhanVien.vue?vue&type=script&lang=js"
export * from "./PopupHuyCapTheChoNhanVien.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__